import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToHash = () => {

  useEffect(() => {
    setTimeout(() => {
      const el = document.getElementById(window.location.hash.replace("#", ""));
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }, 2000)
  }, []);

  return null;
};

export default ScrollToHash;